// extracted by mini-css-extract-plugin
export default {"normalcn":"styles_normalcn__9MzbR","normalen":"styles_normalen__770hF"};